import { Person, Student } from "../../../Utilities";
import { PersonFormValues } from "../Person";
import { RelationshipFormValues } from "../Relationship";
import { StudentAcademicTermEnrollmentFormValues } from "../StudentAcademicTermEnrollment";
import { StudentCourseSectionEnrollmentFormValues } from "../StudentCourseSectionEnrollment";
import { StudentHomeRoomSectionEnrollmentFormValues } from "../StudentHomeRoomSectionEnrollment";
import { StudentMedicalConditionFormValues } from "../StudentMedicalCondition";
import { StudentMedicalContactFormValues } from "../StudentMedicalContact";
import { StudentMedicalEventFormValues } from "../StudentMedicalEvent";
import { StudentMedicalProfileFormValues } from "../StudentMedicalProfile";
import { StudentOTCMedicationFormValues } from "../StudentOTCMedication";
import { StudentPrescriptionMedicationFormValues } from "../StudentPrescriptionMedication";
import { StudentVaccinationRecordFormValues } from "../StudentVaccinationRecord";

export type Base = {
	graduationYear: Student["graduationYear"] | null;
};

export type Create = Base & {
	person: PersonFormValues.CreateInStudent[];
	relationships: RelationshipFormValues.CreateInStudent[];
	studentAcademicTermEnrollments: StudentAcademicTermEnrollmentFormValues.CreateInStudent[];
	studentCourseSectionEnrollments: StudentCourseSectionEnrollmentFormValues.CreateInStudent[];
	studentHomeRoomSectionEnrollments: StudentHomeRoomSectionEnrollmentFormValues.CreateInStudent[];
	studentMedicalConditions: StudentMedicalConditionFormValues.CreateInStudent[];
	studentMedicalContacts: StudentMedicalContactFormValues.CreateInStudent[];
	studentMedicalEvents: StudentMedicalEventFormValues.CreateInStudent[];
	studentMedicalProfile: StudentMedicalProfileFormValues.CreateInStudent[];
	studentOtcMedications: StudentOTCMedicationFormValues.CreateInStudent[];
	studentPrescriptionMedications: StudentPrescriptionMedicationFormValues.CreateInStudent[];
	studentVaccinationRecords: StudentVaccinationRecordFormValues.CreateInStudent[];
};

export type CreateRequiredKey = Extract<keyof Create, "personID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	graduationYear: null,
	person: [PersonFormValues.blankItemInStudent],
	relationships: [],
	studentAcademicTermEnrollments: [],
	studentCourseSectionEnrollments: [],
	studentHomeRoomSectionEnrollments: [],
	studentMedicalConditions: [],
	studentMedicalContacts: [],
	studentMedicalEvents: [],
	studentMedicalProfile: [],
	studentOtcMedications: [],
	studentPrescriptionMedications: [],
	studentVaccinationRecords: [],
};

export type Detail = Base & {
	yearsFromGraduation: Student["yearsFromGraduation"] | null;
	personID: Person["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;
